import {KTIcon} from '../../../../../_metronic/helpers'
import {useQueryResponse} from '../../core/QueryResponseProvider'

const Header = () => {
  const {isLoading, refetch} = useQueryResponse()

  return (
    <div className='card-header border-0 pt-6'>
      <div className='card-title' />
      <div className='card-toolbar'>
        <button
          disabled={isLoading}
          type='button'
          className='btn btn-light-danger me-3'
          onClick={() => refetch()}
        >
          <KTIcon iconName='arrows-circle' className='fs-2' />
          Atualizar
        </button>
      </div>
    </div>
  )
}

export {Header}
